import Vue from "vue";
import Vuex from "vuex";
import auth from "./services/auth";
import { CURRENCY } from "@/commons/enums";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currency: CURRENCY.JPY.language as string
  },
  mutations: {
    setCurrency(state, newCurrency) {
      state.currency = newCurrency;
    }
  },
  modules: {
    auth: auth,
  },
});
